export type RuntimeRef = {
  entityId: string
  versionId?: string
}

export const parseRuntimeRef = (value: string | undefined | null): RuntimeRef | undefined => {
  if (!value) return undefined
  const colonIndex = value.indexOf(':')
  if (colonIndex < 0) return { entityId: value }
  return { entityId: value.slice(0, colonIndex), versionId: value.slice(colonIndex + 1) || undefined }
}

export const formatRuntimeRef = (ref: RuntimeRef | undefined | null): string | null => {
  if (!ref) return null
  return ref.versionId ? `${ref.entityId}:${ref.versionId}` : ref.entityId
}
